import { useMemo } from 'react';

import { Text } from '@kanda-libs/ks-design-library';

import { JobQuoteVariant } from 'components/JobQuote';
import { formatToCurrency } from 'utils';

export interface JobQuotePricesSimpleProps {
  subTotal: number;
  vatTotal: number;
  jobTotal: number;
  variant: JobQuoteVariant;
  isLoading: boolean;
}

const JobQuotePricesSimple: React.FunctionComponent<JobQuotePricesSimpleProps> =
  function ({ subTotal, vatTotal, jobTotal, variant, isLoading }) {
    const majorValueTextClassName = useMemo(
      () =>
        [
          'text-18-22-em text-neutral-900 my-auto text-right',
          variant !== 'full' ? '' : 'md:text-20-24-em',
        ].join(' '),
      [variant],
    );

    const minorHeadingClassName = useMemo(
      () =>
        [
          'text-12-18 text-neutral-600',
          variant !== 'full' ? '' : 'md:text-14-22',
        ].join(' '),
      [variant],
    );

    const majorHeadingClassName = useMemo(
      () =>
        [
          'text-14-22-em text-neutral-900',
          variant !== 'full' ? '' : 'md:text-16-24-em',
        ].join(' '),
      [variant],
    );

    return (
      <>
        <Text
          className="text-14-22 text-neutral-600"
          text="Subtotal"
          isLoading={isLoading}
          skeletonProps={{
            width: 100,
          }}
        />
        <Text
          className="text-14-22 text-neutral-900 text-right"
          text={formatToCurrency(subTotal)}
          isLoading={isLoading}
          skeletonProps={{
            width: 100,
          }}
        />
        <Text
          className="text-14-22 text-neutral-600"
          text="VAT"
          isLoading={isLoading}
          skeletonProps={{
            width: 100,
          }}
        />
        <Text
          className="text-14-22 text-neutral-900 text-right"
          text={formatToCurrency(vatTotal)}
          isLoading={isLoading}
          skeletonProps={{
            width: 100,
          }}
        />
        <div className="col-span-2 border-b border-neutral-300" />
        <div className="flex flex-col">
          <Text
            className={majorHeadingClassName}
            text="Outstanding To Pay"
            isLoading={isLoading}
            skeletonProps={{
              width: 100,
            }}
          />
          <Text
            className={minorHeadingClassName}
            text="In full or with finance"
            isLoading={isLoading}
            skeletonProps={{
              width: 100,
            }}
          />
        </div>
        <Text
          className={majorValueTextClassName}
          text={formatToCurrency(jobTotal)}
          isLoading={isLoading}
          skeletonProps={{
            width: 100,
          }}
        />
      </>
    );
  };

export default JobQuotePricesSimple;
